import { render, staticRenderFns } from "./NuovaPrenotazioneCliente.vue?vue&type=template&id=7363956e&"
import script from "./NuovaPrenotazioneCliente.vue?vue&type=script&lang=js&"
export * from "./NuovaPrenotazioneCliente.vue?vue&type=script&lang=js&"
import style0 from "./NuovaPrenotazioneCliente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports